import { useTranslation } from '@thoughtspot/i18n';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import React from 'react';
import { HelpMenuState, HelpMenuTestIds } from "./help-menu.const";
import styles from './help-menu.module.scss';
export const WhatsNewModal = ({ setHelpMenuState, frameUrl, notesUrl, openExternalUrlInNewTab, }) => {
    const { t } = useTranslation();
    return (React.createElement(Modal, { isOpen: true, size: ModalSize.LARGE, title: t('helpMenuItems.whatsNew.label'), confirmButton: {
            text: t('CLOSE'),
            onConfirm: () => {
                setHelpMenuState(HelpMenuState.CLOSED);
            },
        }, alwaysMaxHeight: true, denyButton: {
            text: t('helpMenuItems.fullReleaseNotes'),
            onDeny: () => {
                openExternalUrlInNewTab(notesUrl);
            },
        }, onDismiss: () => {
            setHelpMenuState(HelpMenuState.CLOSED);
        } },
        React.createElement("iframe", { "data-testid": HelpMenuTestIds.Documentation, src: frameUrl, title: t('helpMenuItems.whatsNew.label'), className: styles.whatsNewFrame, loading: "lazy", allowFullScreen: true })));
};
//# sourceMappingURL=whats-new-modal.js.map